import React, { useState, useEffect } from "react";
import Heading from "../Heading/Heading";
import Carousel from "react-bootstrap/Carousel";
import "./Products.css";
import { client } from "../../client";
import { fetchProducts } from "../../Utils/data";

export default function Products() {
  const [products, setProducts] = useState();

  useEffect(() => {
    client.fetch(fetchProducts).then((data) => {
      setProducts(data);
    });
  }, []);

  return (
    <div className="products padding_top_bottom">
      <div className="container">
        <Heading MainHeader="ENERGY SECTOR – PRODUCT RANGE" />
        <Carousel variant="dark" fade={false} controls={false}>
          {products?.map((product, index) => (
            <Carousel.Item key={index}>
              <div className="product_item">
                <div className="product_image">
                  <img src={product.product_image.asset.url} alt="product" />
                </div>
                <h1>{product.title}</h1>
              </div>
            </Carousel.Item>
          ))}
        </Carousel>
      </div>
    </div>
  );
}
